module.exports = __webpack_public_path__ + "img/reset-password-v2-dark.1d2c910d.svg";